import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnDestroy, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import * as _ from 'lodash';
import { DashboardService } from '@app/cp/shared/services/dashboard.service';
import { DashboardWidgetEvent } from '@app/cp/shared/models/DashboardWidgetEvent';
import { DisplayTarget } from '@app/cp/shared/enums/DisplayTarget';
import { FactoryComponents } from '@app/cp/shared/enums/FactoryComponents';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { DashboardWidgetService } from '@app/cp/shared/services/dashboardWidget.service';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { v_InvoiceBus2 } from '@app/cp/shared/models/v_InvoiceBus2';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { aggregateBy } from '@progress/kendo-data-query';
import { CRUDActions } from '../../../enums/CRUDActions';
import { ConfirmDialogComponent } from '../../../components/confirm-dialog/confirm-dialog.component';
import { ConfirmOutput } from '../../../models/ConfirmOutput';
import { CPDialogResult } from '../../../enums/CPDialogResult';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';
import { CmProAuthService } from '@app/core/services';
import { AppClaims } from '@app/cp/shared/models/AppClaims';
import { SelectionEvent } from '@progress/kendo-angular-grid';

@Component({
    selector: 'cp-invoices-ready-to-post',
    templateUrl: './invoices-ready-to-post.component.html',
    styleUrls: ['./invoices-ready-to-post.component.scss']
})
export class InvoicesReadyToPostGridComponent extends BaseGridComponent<v_InvoiceBus2, null> implements OnInit, OnDestroy, OnChanges {

    public aggregates: any[] = [];
    public aggregateResults;

    searchParam: WidgetSearch;
    subscriptions: Subscription[] = [];
    rights: AppClaims = new AppClaims();
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private svc_data: DispatchesService, private svc_dashWidget: DashboardWidgetService, private svc_dashboard: DashboardService, private authService: CmProAuthService) {
        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
        this.subscriptions.push(svc_dashboard.generalWidgetRefresh$.subscribe(
            refresh => {
                this.loaderState = true;
                this.getData();
            }));
    }

    @Input() inputData: any;
    @Input() dataFilter: WidgetSearch;
    @Input() changeCheck: string;
    @Output() openRequest = new EventEmitter<any>();
    @ViewChild('cnfDialog') protected cnfDialog: ConfirmDialogComponent;
    loaderState: boolean = true;
    invoices: any;

    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public contentTypes = WindowContents;

    initialLoad: boolean = true;

    ngOnInit() {
        this.setup(this.dataFilter);
        this.initialLoad = false;
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.rights = user.appClaims;
            }
        });
    }

    ngOnChanges() {
        this.loaderState = true;
        if (!this.initialLoad) {
            this.setup(this.dataFilter);
        }
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        this.authService.unsubscribeToLoginEvents();
    }

    selectAll: boolean = false;
    selectAllChanged(e: any) {
        this.selectAll = !this.selectAll;
        this.checkAll(this.selectAll);
    }
    checkAll(checked: boolean) {
        for (let i = 0; i < this.gridData.length; i++) {
            this.gridData[i].selected = checked;
        }
        this.canSave = checked;
    }

    getData() {
        this.loaderState = true;
        this.hideError();
        this.svc_dashboard.getMonthEndDrawRecostsGrid(this.searchParam).subscribe(data => {
            if (!data) {
                this.handleNetworkError(null);
            } else {
                this.invoices = data;

                this.gridData = _.cloneDeep(data);
                this.loaderState = false;
                this.canSave = false;
            }
        },
            error => this.handleNetworkError(error));
    }
    confirmDialog(data: ConfirmOutput) {
        let handled: boolean = false;
        if (data.dialogResult === CPDialogResult.ok) {
            switch (data.action) {
                case CRUDActions.Update:
                    handled = true;
                    this.recostJobs();
                    break;
            }
        }
    }

    public refresh() {
        this.getData();
    }
    recostJobsAsk() {
        this.cnfShow("Are you sure you want to continue Finalize Draws?", CRUDActions.Update, null, "Finalize Draws!", " FinalizeDraws", false, true);
    }

    cnfShow(message: string, action: CRUDActions = CRUDActions.None, data: any = null, title: string = null, code: string = null, okButtonOnly = false, yesNo = false) {
        if (CommonFunctions.hasValue(this.cnfDialog)) {
            this.cnfDialog.show(message, action, data, title, code, okButtonOnly, yesNo);
        }
    }
    recostJobs() {
        this.loaderState = true;
        this.hideError();
        var ids = [];
        for (let i = 0; i < this.gridData.length; i++) {
            if (this.gridData[i].selected) {

                ids.push(this.gridData[i].invoiceId);
            }
        }
        this.svc_dashboard.reCostingOfJobs(ids).subscribe(data => {
            if (!data) {
                this.handleNetworkError(null);
            } else {
                if (!data.saveError) {
                    let not: string = "Successfully Finalized";
                    this.getData();
                    this.globals.notifySuccess(not);
                }
                else {
                    this.globals.notifyError(data.message);
                }

                this.getData();
            }
        },
            error => this.globals.notifyError(error, true));
    }

    returnError: boolean = false;

    handleNetworkError(error) {
        this.showError();
    }

    showError() {
        this.loaderState = false;
        this.returnError = true;
    }

    hideError() {
        this.returnError = false;
    }

    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }
    public setup(data: WidgetSearch) {
        this.searchParam = data;
        this.getData();
    }
    details(detailData: v_InvoiceBus2) {
        let w_event: DashboardWidgetEvent = new DashboardWidgetEvent();
        w_event.id = detailData.invoiceId;
        w_event.displayTarget = DisplayTarget.window;
        w_event.factoryComponent = FactoryComponents.DQOI;
        this.svc_dashWidget.nextDashboardWidgetEvent(w_event);
    }

    showDetailsPopup(id: string, type: number) {
        this.svc_dashboard.openDQOIPopup(id, type);
    }
    canSave: boolean = false;
    checkBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {

        dataItem.selected = e.target.checked;
        var i = this.gridData.findIndex(a => a.selected == true);
        this.canSave = (i >= 0);
    }

    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }

    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
            console.log(JSON.stringify(this.aggregateResults));
        }
    }
}
